import { isPlatformBrowser } from '@angular/common';
import { HostListener, Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class UserAgentService {
	isMobile: boolean = false;

	constructor(@Inject(PLATFORM_ID) private platformId: Object) {
		this.screenControl();
	}

	screenControl() {
		if (isPlatformBrowser(this.platformId)) {
			this.isMobile = window.innerWidth > 991 ? false : true;
		}
	}

	verifyMobile() {
		this.screenControl();
		return this.isMobile;
	}
}
